import React, { useState, useEffect, useRef, useMemo, useCallback} from "react";
import "../App.css";
import { Table, Button, DatePicker,  ConfigProvider, Select, InputNumber,Input, Space, Alert,Popconfirm, Switch, message } from "antd";
import { UploadOutlined, DownloadOutlined } from '@ant-design/icons';
import { Upload } from 'antd';
import { PlusOutlined, FilePdfOutlined, CopyOutlined, SnippetsOutlined, RightOutlined, DownOutlined, DeleteOutlined} from "@ant-design/icons";
import { BiSolidSchool } from "react-icons/bi";
import { HiOutlineTicket } from "react-icons/hi2";
import { PiHandCoinsLight } from "react-icons/pi";
import { IoMdBicycle } from "react-icons/io";
import { PiTrainSimple } from "react-icons/pi";
import { LuCarFront } from "react-icons/lu";
import { LuCarTaxiFront } from "react-icons/lu";
import { BsHouse } from "react-icons/bs";
import { CiMap } from "react-icons/ci";
import { FaRegAddressCard } from "react-icons/fa";
import { GiPathDistance } from "react-icons/gi";
import { CiCreditCardOff } from "react-icons/ci";
import { MdDownloading } from "react-icons/md";
import { SiGooglemaps } from "react-icons/si";
import { RiUserShared2Line } from "react-icons/ri";
import dayjs from "dayjs";
import 'dayjs/locale/de'
import deDE from 'antd/locale/de_DE';
import duration from "dayjs/plugin/duration";
import customParseFormat from 'dayjs/plugin/customParseFormat'
import AddressInput from "./AddressInput";
import CalculateDistances from "./CalculateDistances";
import exportPDF from "./exportPDF";
import TextArea from "antd/es/input/TextArea";
import travelAllowance from "../data/travel-allowance.json";
import { compressImage,convertHeicIfNeeded } from "./imageUtils";
import ReceiptCropper from "./ReceiptCropper";
import MailClientModal from "./MailClientModal";
dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.locale('de');


const TripTable = ({ personalData, 
  setPersonalData, 
  schoolData, 
  setSchoolData, 
  visitedPlaces,
  setVisitedPlaces,
  tripData, 
  setTripData, 
  monthlyTicketData, 
  setMonthlyTicketData, 
  confirmation, 
  billingPeriod,
  setBillingPeriod, 
  dataProtection }) => {
  
  const { RangePicker } = DatePicker;
  const createEmptyExpandedRow = (key) => (
   {
  key,
  event: "",
  address: { type: "", name: "", street: "", housenumber: "", postalCode: "", city: "" },
  transportMode: "",
  segmentDistanceOpenRouteService: null,
  segmentDistance: null,
  ticketPrice: null,
  payBackTicketPrice: null,
  passenger: "",
  reason: "",
});
  
  
  const createEmptyParentRow = (key) => ({
    key,
    date: null,
    timeRange: null,
    event: "",
    transport: "",
    perDiem: null,
    payback: null,
    expenses: [{ label: "",
       amount: null,
       receipt: null }],//{name,base64} 
    passengers:"",
    reasons:"",
    expandedData: [
      createEmptyExpandedRow(`${key}-1`),
      createEmptyExpandedRow(`${key}-2`)
    ]
  });


  const transportIcons = {
    Kfz: <LuCarFront />,
    Fahrgemeinschaft: <LuCarTaxiFront />,
    KfzDienstlich: <LuCarTaxiFront />,
    Fahrrad: <IoMdBicycle className="icon-black"/>,
    Öffentliche: <PiTrainSimple className="icon-black" />,
    Mitfahrgelegenheit: <RiUserShared2Line className="icon-black" />
  };

  const locationIcons = {
    Wohnort: <BsHouse/>,
    Stammschule: <BiSolidSchool className="icon-black"/>
  }

  
  const [lastAddressesTransportMode,setLastAddressesTransportMode] = useState([]);
  const [lastEditedKey,setLastEditedKey]=useState(null);
  const [copiedRow, setCopiedRow] = useState(null);
  const [copiedSubRow, setCopiedSubRow] = useState(null);
  const [showAlertConfirmation, setShowAlertConfirmation] = useState(false);
  const [showAlertDataProtection, setShowAlertDataProtection] = useState(false);
  const [showAlertStatusError, setShowAlertStatusError] = useState(false);
  const [missingData, setMissingData] = useState(false);
  const [cropImage, setCropImage] = useState(null);
  const [cropVisible, setCropVisible] = useState(false);
  const [currentExpense, setCurrentExpense] = useState(null);
  const [cropFile, setCropFile] = useState(null);
  const [cropOpen, setCropOpen] = useState(false);
  const [loading,setLoading] =useState(false);
  const [mailModal, setMailModal] = useState({ open: false, blob: null, fileName: "" });
  const isCalculatingRef = useRef(false);
  


// JSON-Daten exportieren
const handleExport = () => {
  const dataToExport = {
    trips: tripData,
    monthlyTicket: monthlyTicketData,
    personalData: personalData,
    schoolData: schoolData,
    timestamp: new Date().toISOString()
  };

  const jsonStr = JSON.stringify(dataToExport, null, 2);
  const blob = new Blob([jsonStr], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  
  const a = document.createElement('a');
  a.href = url;
  a.download = `reisedaten_${new Date().toISOString().slice(0,10)}.json`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

/*const parseDate = (value) => {
  if (!value) return null;
  if (dayjs.isDayjs(value)) return value;
console.log(dayjs(value, "DD.MM.YY",true));
  return dayjs(value, "DD.MM.YY",true);
  
};

const parseDateRange = (range) => {
  if (!Array.isArray(range) || range.length !== 2) return null;

  const from = parseDate(range[0]);
  const to = parseDate(range[1]);

  return from && to ? [from, to] : null;
};



const normalizeTrip = (trip) => ({
  ...trip,
  date: parseDate(trip.date)
});

const normalizeImportData = (data) => ({
  ...data,
  trips: Array.isArray(data.trips)
    ? data.trips.map(normalizeTrip)
    : []
});
*/

// JSON-Daten importieren
const handleImport = (file) => {
  const reader = new FileReader();
  reader.onload = (e) => {
    try {
      const data = JSON.parse(e.target.result);
      
      if (!data.trips || !Array.isArray(data.trips)) {
        throw new Error("Ungültiges Dateiformat");
      }

    //  const normalizedData = normalizeImportData(data)
      

setTripData(data.trips);


      
      if (data.monthlyTicket) {
        setMonthlyTicketData(data.monthlyTicket);
      }

      if(data.personalData){
        setPersonalData(data.personalData);
      }

      if(data.schoolData){
        setSchoolData(data.schoolData);
      }


      

      updateBillingPeriod(data.trips)

      
      message.success("Daten erfolgreich importiert");
    } catch (error) {
      message.error(`Fehler beim Import: ${error.message}`);
    }
  };
  reader.readAsText(file);
  return false; // Verhindert Standardverhalten
};




  


  /*useEffect(() => {
    const parentItem = tripData.find((item) => item.key === lastEditedKey);
    if (!parentItem) return;
   const isCompleteAddress = parentItem.expandedData.every(
  (item) => item.address.postalCode?.length === 5 && item.address.city && item.transportMode
);

    if(!isCompleteAddress ) return;
    
    // Extrahiere nur die Adressen als JSON-String
    const currentAddresses = JSON.stringify(parentItem.expandedData.map((item) => item.address));
 


  

    // Nur wenn sich die Adressen geändert haben, berechnen wir die Distanz neu
    if (currentAddresses !== lastAddresses) {
      setLastAddresses(currentAddresses);

      console.log(currentAddresses);
      tripData.forEach((item) => updateSegmentDistances(item.key))
      
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tripData, lastEditedKey]); 

  */

  //Abhängigkeitsparameter für nachfolgenden useEffect   
  const publicTicketPrices = useMemo(() => {
    return tripData.flatMap(parent =>
      parent.expandedData
        .filter(sub => sub.transportMode === ("Öffentliche" || "ÖffentlicheOhneMonatsticket") && sub.ticketPrice)
        .map(sub => sub.ticketPrice)
    ).join("|");  // Durch Join wird ein String erzeugt, ansonsten bleibt es ein Array, das neu erzeugt wird, wenn sich tripData ändert, selbst, wenn die Array-Inhalte gleich sind
  }, [tripData]);




  const updateDate = useMemo(() => {
    return tripData.flatMap(parent =>
      parent.dateRange).join("|");  // Durch Join wird ein String erzeugt, ansonsten bleibt es ein Array, das neu erzeugt wird, wenn sich tripData ändert, selbst, wenn die Array-Inhalte gleich sind
  }, [tripData]); 
  
 
const totalRefund = useMemo(() => {
  return tripData.reduce((total, item) => {
    const paybackValue = item.payback?? 0;
    return total + paybackValue;
  }, 0);
}, [tripData]);

const isDateOutsideValidityPeriod = useCallback((date) => {
  if (
    !monthlyTicketData.active ||
    !monthlyTicketData.validityPeriod ||
    !date
  ) return false;

  // Wenn date ein String ist, zuerst Dayjs daraus machen
  const travelDate = dayjs(date);
  if (!travelDate.isValid()) return false;

  const fromDate = dayjs(monthlyTicketData.validityPeriod[0]);
  const toDate = dayjs(monthlyTicketData.validityPeriod[1]);

  if (!fromDate.isValid() || !toDate.isValid()) return false;

  return travelDate.isBefore(fromDate, "day") || travelDate.isAfter(toDate, "day");
}, [monthlyTicketData]);

  const calculatePayBackTicketPrice = useCallback((currentTicketPrice, cumulativeSum) => {
      const totalIncludingCurrent = cumulativeSum + currentTicketPrice;
      if(!monthlyTicketData.price) return currentTicketPrice;
      if (totalIncludingCurrent <= monthlyTicketData.price) {
        return currentTicketPrice; // Vollständige Erstattung
      } else {
        const remaining = monthlyTicketData.price - cumulativeSum;
        return Math.max(0, remaining); // Nur den Restbetrag erstatten
      }
    },[monthlyTicketData]);



  useEffect(() => {
    
    tripData.forEach(item => {
      if (item.date && isDateOutsideValidityPeriod(item.date)) {
        message.warning({
          content: `Reisedatum ${item.date} liegt außerhalb des Gültigkeitsbereichs der Monatskarte (${monthlyTicketData.validityPeriod[0]} bis ${monthlyTicketData.validityPeriod[1]})`,
          duration: 5,
          key: `date-warning-${item.key}`
        });
      }
    });
  }, [tripData, monthlyTicketData,isDateOutsideValidityPeriod]);
 
useEffect(()=>{
  setMissingData( tripData.some(item =>
  item.expandedData.some(subItem => (subItem.transportMode === "Fahrgemeinschaft" && subItem.passenger === "") ||
  ((parseFloat(subItem.segmentDistance)>parseFloat(subItem.segmentDistanceOpenRouteService)*1.05+2) 
       && ["Kfz", "Fahrgemeinschaft", "KfzDienstlich", "Fahrrad"].includes(subItem.transportMode) && subItem.reason === "")
 )
          ));
},[tripData])
  // updatePayBackTicketPrice
 useEffect(() => {    
    let cumulativeSum = 0;
    const newTripData = tripData.map(parent => ({
        ...parent,
        expandedData: parent.expandedData.map(subItem => {
          if (subItem.transportMode ==="Öffentliche") {
            const currentPrice = subItem.ticketPrice!==null ? parseFloat(subItem.ticketPrice) : 0;
            const payBack = (!isDateOutsideValidityPeriod(parent.date) && subItem.transportMode === "Öffentliche")
            
             ? calculatePayBackTicketPrice(currentPrice, cumulativeSum):currentPrice;
            cumulativeSum += currentPrice;
            return { ...subItem, payBackTicketPrice: payBack };
          }
          if (subItem.transportMode ==="ÖffentlicheOhneMonatsticket") {
            const currentPrice = subItem.ticketPrice!==null ? parseFloat(subItem.ticketPrice) : 0;
            return { ...subItem, payBackTicketPrice: currentPrice };
          }

          return subItem;
        }),
      }));
      if(JSON.stringify(newTripData) !== JSON.stringify(tripData)){
        setTripData(newTripData);
      } 
      

}, [publicTicketPrices,
  calculatePayBackTicketPrice,
  monthlyTicketData,
  updateDate,isDateOutsideValidityPeriod,
  tripData,setTripData]);

const handleTransportChange = (parentKey, recordKey, value) => {
  const resetPassengerModes = [
    "Kfz",
    "Öffentliche",
    "ÖffentlicheOhneMonatsticket",
    "KfzDienstlich",
    "Fahrrad",
  ];

  const shouldResetPassenger = resetPassengerModes.includes(value);

  setTripData((prevData) =>
    prevData.map((item) =>
      item.key === parentKey
        ? {
            ...item,
            expandedData: item.expandedData.map((subItem) =>
              subItem.key === recordKey
                ? {
                    ...subItem,
                    transportMode: value,
                    ...(shouldResetPassenger && { passenger: "" }),
                  }
                : subItem
            ),
          }
        : item
    )
  );

  updateSegmentDistances(parentKey);
};



// Berechnung der Gesamtkosten

  useEffect(()=>{

    const newTripData = tripData.map((item) =>{
      
  
        // Fahrtkosten berechnen
        let travelCost = item.expandedData.reduce((totalCost, entry) => {
          const mode = entry.transportMode;
          const distance = parseFloat(entry.segmentDistance) || 0;
          const price = parseFloat(entry.payBackTicketPrice) || 0;
  
          switch (mode) {
            case "Kfz":
              return totalCost + distance * travelAllowance.kfz;
            case "Fahrrad":
              return totalCost + distance * travelAllowance.fahrrad;
            case "KfzDienstlich":
              return totalCost + distance * travelAllowance.kfzDienstlich;
            case "Fahrgemeinschaft":
              return totalCost + distance * travelAllowance.fahrgemeinschaft;
            case "Öffentliche":
              return totalCost + price;
            case "ÖffentlicheOhneMonatsticket":
              return totalCost + price;
            default:
              return totalCost;
          }
        }, 0);
  
        // Per Diem und Nebenkosten berechnen
        const perDiem = parseFloat(item.perDiem) || 0;
        const expenses = item.expenses && item.expenses.length > 0
  ? item.expenses.reduce((acc, curr) => acc + (parseFloat(curr.amount) || 0), 0)
  : 0;

  
        // Gesamte Erstattung berechnen
        const totalPayback = (travelCost + perDiem + expenses);
  
        return { ...item, payback: totalPayback };
      })
    
    if(JSON.stringify(newTripData) !== JSON.stringify(tripData)){
        setTripData(newTripData);
      } 

  },[setTripData,tripData]);
 

const isValidAddress = (a) =>
  a?.postalCode?.trim() &&
  a?.city?.trim();

  const addressesEqual = (a, b) => {
  if (!a || !b) return false;
  return (
    (a.street ?? "") === (b.street ?? "") &&
    (a.housenumber ?? "") === (b.housenumber ?? "") &&
    (a.postalCode ?? "") === (b.postalCode ?? "") &&
    (a.city ?? "") === (b.city ?? "")
  );
};

function formatAddress(a) {
  if (!a?.postalCode || !a?.city) return null;

  const parts = [];

  if (a.street) {
    parts.push(
      a.housenumber
        ? `${a.street} ${a.housenumber}`
        : a.street
    );
  }

  parts.push(`${a.postalCode} ${a.city}`);

  return parts.join(", ");
}

const toIsoDate = (date) => {
  return date ? date.toISOString() : null;
}

const toIsoDateRange = (dates) => {
  if (!dates) return null;

  const from = dates[0];
  const to = dates[1];

  if (!from || !to) return null;
  if (!from.isValid() || !to.isValid()) return null;

  return [from.toISOString(), to.toISOString()];
}

const toIsoTimeRange = (times) => {
  if (!times) return null;

  const from = times[0];
  const to = times[1];

  if (!from || !to) return null;

  return [from.toString(), to.toString()];
}









const updateSegmentDistances = async (parentKey, force = false) => {
  if (isCalculatingRef.current && !force) return;
  isCalculatingRef.current = true;

  try {
    const keyToUse = parentKey ?? lastEditedKey;
    const parentItem = tripData.find((it) => it.key === keyToUse);
    if (!parentItem) return;

    const current = parentItem.expandedData.map((it) => ({
      adress: it.address,
      transportAllowed: ["Kfz", "Fahrgemeinschaft", "KfzDienstlich", "Fahrrad"].includes(it.transportMode),
    }));

    const last = Array.isArray(lastAddressesTransportMode)
      ? lastAddressesTransportMode
      : [];

    // ⛔ Initialdurchlauf → NICHT blockieren
    if (last.length === 0 && !force) {
      setLastAddressesTransportMode(current);
      return;
    }

    const segmentsToUpdate = [];
    for (let i = 0; i < current.length - 1; i++) {
      if (!current[i].transportAllowed) continue;

      const changed =
        !addressesEqual(current[i].adress, last[i]?.adress) ||
        !addressesEqual(current[i + 1]?.adress, last[i + 1]?.adress);

      if (changed || force) segmentsToUpdate.push(i);
    }

    if (segmentsToUpdate.length === 0) return;

    const distanceResults = {};

    for (const i of segmentsToUpdate) {
      const a1 = current[i].adress;
      const a2 = current[i + 1].adress;

      if (!isValidAddress(a1) || !isValidAddress(a2)) {
        distanceResults[i] = null;
        continue;
      }

      const start = formatAddress(a1);
      const end = formatAddress(a2);
      const distance = await CalculateDistances([start, end]);
      const km = parseFloat(distance);

      distanceResults[i] = isNaN(km) ? null : km.toFixed(1);
    }

    setTripData((prev) =>
      prev.map((it) =>
        it.key === keyToUse
          ? {
              ...it,
              expandedData: it.expandedData.map((sub, idx) =>
                distanceResults[idx] !== undefined
                  ? { ...sub, segmentDistanceOpenRouteService: distanceResults[idx] }
                  : sub
              ),
            }
          : it
      )
    );

    setLastAddressesTransportMode(current);
  } finally {
    isCalculatingRef.current = false;
  }
};



const updateExpandedAddress = (parentKey, subKey, newAddress) => {
  setTripData(prev =>
    prev.map(parent =>
      parent.key === parentKey
        ? {
            ...parent,
            expandedData: parent.expandedData.map(sub =>
              sub.key === subKey
                ? { ...sub, address: newAddress }
                : sub
            ),
          }
        : parent
    )
  );
  
};

 

const handleAddressBlur = (parentKey, record) => {

  saveAddress(parentKey, record);
  
 // updateSegmentDistances(parentKey);
   // aktualisiert tripData
};

const handleVisitedPlaceBlur = (address) => {
  updateVisitedPlaces(address);
};

  const saveAddress = async (parentKey,record) => {
   setLastEditedKey(parentKey);
    setTripData((prevData) =>
      prevData.map((item) =>
        item.key === parentKey
          ? {
              ...item,
              expandedData: item.expandedData.map((subItem) =>
                subItem.key === record.key
                  ? { ...subItem, address: record.address }
                  : subItem
              ),
            }
          : item
      )
    );
   
    
    
   
  }
  
 
  const updatePerDiem = (parentKey) => {
    setTripData((prevData) =>
      prevData.map((item) => {
        if (item.key !== parentKey) return item;

        const times = item.timeRange;
        
        
        if (times.length < 2) return { ...item, perDiem: "0 €" };

        const startTime =  times  ? dayjs(` ${times[0]}`, "HH:mm"):  dayjs();
        const endTime =  times  ? dayjs(` ${times[1]}`, "HH:mm"): dayjs();
        const diff = dayjs.duration(endTime.diff(startTime)).asHours();
        switch(true)
        {
          case diff>=14: 
          return { ...item, perDiem: "12 €" };
          case diff<14 && diff>=8:
          return { ...item, perDiem: "6 €" }; 
          default: 
          return { ...item, perDiem: "0 €" };
        }
      })
    );
  };

 const updateRangePicker = (dates, timeStrings, record) => {
let startTime = null;
let endTime = null;
  if(timeStrings && timeStrings[0] && timeStrings[1]){
    [startTime, endTime] = timeStrings;

  }
            
            setTripData((prevData) =>
              prevData.map((item) =>
                item.key === record.key ? { ...item, timeRange: [startTime, endTime] } : item
              )
            );}
 
const updateDatePicker = (value,record) => {
  setTripData((prevData) =>
              prevData.map((item) =>
                item.key === record.key ? { ...item, date: value } : item
              )
            );

            if (
              record.expandedData.some(item => item.transportMode === "Öffentliche") &&
              monthlyTicketData.active &&
              (monthlyTicketData.validityPeriod || []).length === 2 &&
              isDateOutsideValidityPeriod(value)
            ) {
              message.warning({
                content: `Reisedatum liegt außerhalb des Gültigkeitsbereichs der Monatskarte (${monthlyTicketData.validityPeriod[0]} bis ${monthlyTicketData.validityPeriod[1]})`,
                duration: 5,
                key: `date-warning-${record.key}`
              });
            }
}

const updateVisitedPlaces = (address) => {
  if (!address?.city || !address?.postalCode) return;

  setVisitedPlaces(prev => {
    const exists = prev.some(p =>
      (p.city === address.city || p.postalCode === address.postalCode)&&
      p.street === address.street &&
      p.housenumber === address.housenumber
    );

    return exists ? prev : [...prev, address];
  });
}; 


            
  // 1. Neue Zeile hinzufügen
  const handleAddParentRow = () => {
    const newParentKey = Date.now().toString();
    const newParentRow = createEmptyParentRow(newParentKey);
    setTripData([...tripData, newParentRow]);
  };
  

  const handleAddSubRow = async (parentKey) => {
    const newKey = `${parentKey}-${Date.now()}`;
    setTripData((prevData) =>
      prevData.map((item) =>
        item.key === parentKey
          ? {
              ...item,
              expandedData: [
                ...item.expandedData,
                createEmptyExpandedRow(newKey)
              ],
            }
          : item
      )
    );
  };

  // 2. Zeile löschen
  const handleDeleteParentRow = (key) => {
    tripData.length === 1 ? setTripData([createEmptyParentRow(key)] ):
    setTripData(tripData.filter(item => item.key !== key));
    handleBillingPeriod(tripData.filter(item => item.key !== key),null);
  };

  const handleDeleteSubRow = (parentKey, subKey) => {
  tripData.find(item => item.key === parentKey).expandedData.length === 1 ? 
  setTripData((prevData) =>
    prevData.map((item) =>
      item.key === parentKey
        ? { ...item, expandedData:[createEmptyExpandedRow(subKey)],  }
        : item
    )
  ): setTripData((prevData) =>
      prevData.map((item) =>
        item.key === parentKey
          ? { ...item, expandedData: item.expandedData.filter((subItem) => subItem.key !== subKey) }
          : item
      )
    );
  };
  
  // 3. Zeile kopieren
  const handleCopyRow = (key) => {
    const rowToCopy = tripData.find(item => item.key === key);
    if (rowToCopy) {
      setCopiedRow({ ...rowToCopy, key: Date.now().toString(), date: null, expenses: rowToCopy.expenses.map( subitem => ({...subitem, amount: null}) ) }); 
    }
  };

  const handleCopySubRow = (parentKey, subKey) => {
    const parentItem = tripData.find((item) => item.key === parentKey);
    if (!parentItem) return;
  
    const rowToCopy = parentItem.expandedData.find((subItem) => subItem.key === subKey);
    if (rowToCopy) {
      setCopiedSubRow({ ...rowToCopy, key: `${parentKey}-${Date.now()}`,transportMode: "", segmentDistanceOpenRouteService: null,
   segmentDistance: null,
   ticketPrice: null,
   payBackTicketPrice: null,
   passenger: "",
   reason: "" });
    }
  };
  
  // 4. Kopierte Zeile einfügen
  const handlePasteRow = () => {
    if (copiedRow) {
      setTripData([...tripData, copiedRow]);
      setCopiedRow(null);
    }
  };

  const handlePasteSubRow = (parentKey) => {
    if (!copiedSubRow) return;
  
    setTripData((prevData) =>
      prevData.map((item) =>
        item.key === parentKey
          ? { ...item, expandedData: [...item.expandedData, { ...copiedSubRow, key: `${parentKey}-${Date.now()}` }] }
          : item
      )
    );
    setCopiedSubRow(null);
  };

  const handleBillingPeriod = (tripData,value) => {
    const sortDate = [
  ...tripData.map(item => item.date ? dayjs(item.date) : null), 
  value? dayjs(value): null]
  .filter(date => date !== null) // Entfernt alle null-Werte
  .sort((a, b) => a.valueOf() - b.valueOf())
  .map(date => date.format('DD.MM.YY'));
  const lastIndex = sortDate.length-1;
  setBillingPeriod([sortDate[0],sortDate[lastIndex]]);
  }

  const updateBillingPeriod = (tripData) => {
    const sortDate = [
  ...tripData.map(item => item.date ? dayjs(item.date) : null)]
  .filter(date => date !== null) // Entfernt alle null-Werte
  .sort((a, b) => a.valueOf() - b.valueOf())
  .map(date => date.format('DD.MM.YY'));
  const lastIndex = sortDate.length-1;
  setBillingPeriod([sortDate[0],sortDate[lastIndex]]);
  }
  
  // 5. Zeilen vertauschen
 /* const handleMoveRow = (index, direction) => {
    const newData = [...tripData];
    const targetIndex = index + direction;
  
    if (targetIndex >= 0 && targetIndex < newData.length) {
      [newData[index], newData[targetIndex]] = [newData[targetIndex], newData[index]];
      setTripData(newData);
    }
  };*/


  const columns = [
    {
      title: "Aktionen",
      key: "actions",
      width: 100,
      render: (_, record, index) => (
        <>
          <Button  icon={<CopyOutlined />} type="text" size="small"  onClick={() => handleCopyRow(record.key)} />
          <Button icon={<SnippetsOutlined />} type="text" size="small" onClick={handlePasteRow} disabled={!copiedRow} />
          {/*<Button icon={<ArrowUpOutlined />} onClick={() => handleMoveRow(index, -1)} disabled={index === 0} />*/}
          {/*<Button icon={<ArrowDownOutlined />} onClick={() => handleMoveRow(index, 1)} disabled={index === tripData.length - 1} />*/}
          
          <Popconfirm
            title= "Sind Sie sicher, dass Sie diese Reise löschen möchten?"
            onConfirm = {() => handleDeleteParentRow(record.key)}
            okText="Ja"
            cancelText="Abbrechen"
          > 
          <Button icon={<DeleteOutlined />} type="text" size="small"  /> 
          </Popconfirm>
          {index === tripData.length - 1 &&(<Button icon={<PlusOutlined />} type="text" size="small" onClick={handleAddParentRow} />) }
          </>
      ),
    },
    
    


// In deiner columns-Definition
{
  title: (
      <span style={{ whiteSpace: "pre-wrap" }}>
        Datum<br />Reisedauer
      </span>
    ),
  dataIndex: ["date","timeRange"], 
  key: "dateRange",
  width: 200,
  sorter: (a, b) => {
    const aTime = a.date ? new Date(a.date) : 0;
    const bTime = b.date ? new Date(b.date) : 0;
    return aTime - bTime;
  },
  sortDirections: ['ascend', 'descend'],
  render: (text, record) => {
    
   
    const isOutside = record.date ? isDateOutsideValidityPeriod(record.date) : false;

    return (
      <>
      <Space direction="vertical">
      <ConfigProvider locale={deDE}>
        <DatePicker
        style={{width:"150px"}}
        format={'DD.MM.YY'}
        placeholder="Datum"
        value={tripData.find(item => item.key === record.key)?.date
        && dayjs(tripData.find(item => item.key === record.key)?.date).isValid()
      ? dayjs(tripData.find(item => item.key === record.key)?.date)
      : null
  }
          onChange={(value) => {
          
            updateDatePicker(toIsoDate(value),record);
            handleBillingPeriod(tripData,toIsoDate(value));
          }
          }
          status={record.expandedData.find(item => item.transportMode === "Öffentliche") && isOutside ? 'warning' : ''}
         />
         </ConfigProvider>
         <ConfigProvider locale={deDE}>
        <RangePicker
        minuteStep={15} 
        hourStep={1}
        showTime={{ format: 'HH:mm' }}
  format="HH:mm"
  picker="time"
  style={{width:"150px"}}                  
  value={
  tripData.find(item => item.key === record.key)?.timeRange?.[0] &&
  tripData.find(item => item.key === record.key)?.timeRange?.[1]
    ? [
        dayjs(tripData.find(item => item.key === record.key).timeRange[0], "HH:mm"),
        dayjs(tripData.find(item => item.key === record.key).timeRange[1], "HH:mm"),
      ]
    : null
}

          onChange={(dates, timeStrings) => {

            updateRangePicker(dates,toIsoTimeRange(timeStrings),record);
            updatePerDiem(record.key);
          
          }
          }
        
        />
        </ConfigProvider>
        </Space>
        
        {isOutside && record.expandedData.some(item => item.transportMode === "Öffentliche") && (
          <div style={{ color: 'orange', fontSize: 12, marginTop: 4 }}>
            Reisedatum liegt außerhalb des Gültigkeitsbereichs der Monatskarte
          </div>
        )}
      </>
    );
  },
},
    {
      title: 'Anlass der Reise (Veranstaltung)',
      key: "event",
      dataIndex: "event",
      width:150,
      render: (text, record) => (
        <TextArea
          placeholder={"Anlass der \n Reise"}
          autoSize={{ minRows: 1, maxRows: 3 }}
          allowClear
          value={record.event || undefined}

          onChange={(e) =>
            setTripData((prevData) =>
              prevData.map((item) =>
                item.key === record.key ? { ...item, event: e.target.value } : item
              )
            )
          }
          style={{ overflowWrap: 'break-word',wordBreak: 'break-all'  }}
          
        />
      ),
    },
    {
      title: "Route",
      key: "route",
      width: 200,
      render: (_, record) => {
        const routes = record.expandedData
          .filter((entry) => entry.address.city) 
          .map((entry) => {
            const icon = locationIcons[entry.address.type] || null;
            const city = entry.address.city || null;
            return icon && city? (
            

              <div key={entry.key} style={{ marginRight: 8 }}>
                {icon} {city}  </div>
      
            ) : city? <div key={entry.key} style={{ marginRight: 8 }}>
            {city}
            </div> : null;
          });
    
        return routes.length > 0 ? routes.reduce((prev, curr) => [prev, curr]) : null;
      },
    },
    {
      title: "Transport",
      key: "transport",
      width: 340,
      render: (_, record) => {
        const isOutside = record.date ? isDateOutsideValidityPeriod(record.date) : false;
        
const TransportRow = ({ mainIcon, parts }) => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "20px auto",
      alignItems: "center",
      columnGap: "7px",
    }}
  >
    <div>{mainIcon}</div>
    <div>{parts}</div>
    
  </div>
);

const transportRenderers = {
  Kfz: (entry) => (
    <TransportRow
      mainIcon={transportIcons.Kfz}
      parts= {<> 
      <CiMap className="icon-black" /> 
     {Number.isFinite(parseFloat(entry.segmentDistanceOpenRouteService))
  ? parseFloat(entry.segmentDistanceOpenRouteService).toFixed(1).replace(".", ",")
  : "--"} km | <GiPathDistance className="icon-black"/>

      {` ${(entry.segmentDistance??0).toFixed(1).replace(".",",")} km | `}
      <PiHandCoinsLight className="icon-black" />
      {` ${(parseFloat(entry.segmentDistance || 0)*travelAllowance.kfz).toFixed(2).replace(".",",")} €`}
      </>}
       
      
    />
  ),
KfzDienstlich: (entry) => (
    <TransportRow
      mainIcon={transportIcons.KfzDienstlich}
      parts= {<> 
      <CiMap className="icon-black" /> 
      {Number.isFinite(parseFloat(entry.segmentDistanceOpenRouteService))
  ? parseFloat(entry.segmentDistanceOpenRouteService).toFixed(1).replace(".", ",")
  : "--"} km | <GiPathDistance className="icon-black"/>
      {` ${(entry.segmentDistance??0).toFixed(1).replace(".",",")} km | `}
      <PiHandCoinsLight className="icon-black" />
      {` ${(parseFloat(entry.segmentDistance)*travelAllowance.kfzDienstlich ||0).toFixed(2).replace(".",",")} €`}
      </>}
       
      
    />
  ),

  Fahrgemeinschaft: (entry) => (
    <TransportRow
      mainIcon={transportIcons.Fahrgemeinschaft}
      parts= {<> 
      <CiMap className="icon-black" /> 
    {Number.isFinite(parseFloat(entry.segmentDistanceOpenRouteService))
  ? parseFloat(entry.segmentDistanceOpenRouteService).toFixed(1).replace(".", ",")
  : "--"} km | <GiPathDistance className="icon-black"/>
      {` ${(entry.segmentDistance??0).toFixed(1).replace(".",",")} km | `}
      <PiHandCoinsLight className="icon-black" />
      {` ${(parseFloat(entry.segmentDistance || 0)*travelAllowance.fahrgemeinschaft).toFixed(2).replace(".",",") || ""} €`}
      </>}
    />
  ),
  Öffentliche: (entry, { monthlyTicketData, isOutside }) => {
    if (monthlyTicketData.active && !isOutside) {
      return (
       <TransportRow
      mainIcon={transportIcons.Öffentliche}
      parts={<>
      <FaRegAddressCard className="icon-black" /> 
      {` ${(Number(monthlyTicketData.price??0)).toFixed(2).replace(".",",")} € | `}
      <HiOutlineTicket className="icon-black" /> 
      {` ${(Number(entry.ticketPrice??0)).toFixed(2).replace(".",",")} € | `} 
      <PiHandCoinsLight className="icon-black" />  
      {` ${(Number(entry.payBackTicketPrice??0)).toFixed(2).replace(".",",")} €`}
      </>
      }
    
      />   

     
    
      );
    }
    return (
      <TransportRow
        mainIcon={transportIcons.Öffentliche}
        parts={<>
      <CiCreditCardOff  className="icon-black" /> 
      {`  | `}
      <HiOutlineTicket className="icon-black" /> 
      {` ${(Number(entry.ticketPrice??0)).toFixed(2).replace(".",",")} € | `} 
      <PiHandCoinsLight className="icon-black" />  
      {` ${(Number(entry.payBackTicketPrice??0)).toFixed(2).replace(".",",")} €`}
      </>
      }
      />
    );
  },
  ÖffentlicheOhneMonatsticket: (entry) => {
    
    return (
      <TransportRow
        mainIcon={transportIcons.Öffentliche}
        parts={<>
      <CiCreditCardOff  className="icon-black" /> 
      {`  | `}
      <HiOutlineTicket className="icon-black" /> 
      {` ${(Number(entry.ticketPrice??0)).toFixed(2).replace(".",",")} € | `} 
      <PiHandCoinsLight className="icon-black" />  
      {` ${(Number(entry.payBackTicketPrice??0)).toFixed(2).replace(".",",")} €`}
      </>
      }
      />
    );
  },


  Fahrrad: (entry) => (
    <TransportRow
      mainIcon={transportIcons.Fahrrad}
      parts= {<> 
      <CiMap className="icon-black" /> 
      {Number.isFinite(parseFloat(entry.segmentDistanceOpenRouteService))
  ? parseFloat(entry.segmentDistanceOpenRouteService).toFixed(1).replace(".", ",")
  : "--"} km | <GiPathDistance className="icon-black"/>
      {` ${(entry.segmentDistance??0).toFixed(1).replace(".",",")} km | `}
     <PiHandCoinsLight className="icon-black" />
      {` ${(parseFloat(entry.segmentDistance ||0)*travelAllowance.fahrrad).toFixed(2).replace(".",",")} €`}
      </>}
    />
  ),
Mitfahrgelegenheit: (entry) => (
    <TransportRow
      mainIcon={transportIcons.Mitfahrgelegenheit}
      parts= {<> 
      </>}
    />
  ),

};






        const transportModes = record.expandedData
      .filter((entry) => entry.transportMode)
      .map((entry) => {
        const renderer = transportRenderers[entry.transportMode];
        if (!renderer) return null;
        return (
          <div key={entry.key} style={{ marginBottom: 4 }}>
            {renderer(entry, { monthlyTicketData, isOutside })}
          </div>
        );
      })
      .filter(Boolean);

    return transportModes.length > 0 ? (
      <>
        {transportModes.map((mode, index) => (
          <React.Fragment key={index}>
            {mode}
            {index < transportModes.length - 1 && <br />}
          </React.Fragment>
        ))}
      </>
    ) : null;
  },
},
    { 
      title: "Tage- \n geld",
      key: "perDiem", 
      dataIndex: "perDiem", 
      width: 80, 
      render: (text) => text 
    },
      {
  title: "Nebenkosten",
  key: "expenses",
  dataIndex: "expenses",
  width: 350,
  render: (_, record) => (
    <>
      {(record.expenses || [{ label: "", amount: null }]).map((expense, idx) => (
        <div
          key={idx}
          style={{ display: "flex", alignItems: "center", marginBottom: 4 }}
        > 
        <Space size={'small'}>
          <Space.Compact>
  <Input
    style={{ width: 120 }}
    placeholder="Bezeichnung"
    value={expense.label}
    onChange={(e) => {
      const value = e.target.value;
      setTripData((prevData) =>
        prevData.map((item) =>
          item.key === record.key
            ? {
                ...item,
                expenses: item.expenses.map((ex, i) =>
                  i === idx ? { ...ex, label: value } : ex
                ),
              }
            : item
        )
      );
    }}
  />
  <InputNumber
    style={{ width: 100 }}
    placeholder="Betrag"
    value={expense.amount}
    controls={false}
    type = "number"
    precision={2}
    suffix="€"
    onChange={(value) => {
      setTripData((prevData) =>
        prevData.map((item) =>
          item.key === record.key
            ? {
                ...item,
                expenses: item.expenses.map((ex, i) =>
                  i === idx ? { ...ex, amount: value } : ex
                ),
              }
            : item
        )
      );
    }}
  />
</Space.Compact>


         

         
          
  <Upload
  accept="image/*"
  capture="environment"
  showUploadList={false}
  beforeUpload={async (file) => {
  setCropFile(file);
  setCurrentExpense({
    recordKey: record.key,
    expenseIndex: idx
  });
  setCropOpen(true);

  return false; // kein Auto-Upload
}}
>
  <Button
    icon={<HiOutlineTicket />}
    size="small"
    type={expense.receipt ? "primary" : "default"}
  />
</Upload>
{cropFile && (
  <ReceiptCropper
    file={cropFile}
    open={cropOpen}
    onClose={() => setCropOpen(false)}
    onSave={(croppedBase64) => {
      setTripData(prev =>
        prev.map(item =>
          item.key === currentExpense.recordKey
            ? {
                ...item,
                expenses: item.expenses.map((ex, i) =>
                  i === currentExpense.expenseIndex
                    ? {
                        ...ex,
                        receipt: {
                          name: cropFile.name,
                          base64: croppedBase64
                        }
                      }
                    : ex
                )
              }
            : item
        )
      );

      setCropOpen(false);
    }}
  />
)}



<Button
            icon={<DeleteOutlined />}
            type="text"
            size="small"
            onClick={() => {
              setTripData((prevData) =>
                prevData.map((item) =>
                  item.key === record.key && item.expenses.length > 1
                    ? {
                        ...item,
                        expenses: item.expenses.filter((_, i) => i !== idx),
                      }
                    : item.key === record.key && item.expenses.length === 1
                    ? { ...item, expenses: [{ label: "", amount: null }] }
                    : item
                )
              );
            }}
          />

          {idx === record.expenses.length - 1 && (
  <Button
    icon={<PlusOutlined />}
    type="text"
    size="small"
    style={{ marginLeft: 4 }}
    onClick={() => {
      setTripData((prevData) =>
        prevData.map((item) =>
          item.key === record.key
            ? {
                ...item,
                expenses: [
                  ...(item.expenses || []),
                  { label: "", amount: null },
                ],
              }
            : item
        )
      );
    }}
  />
  
)}
</Space>
        </div>
      ))}

      {record.expenses[0].amount > 0 && (
        <div
          className="messages"
          style={{ color: "gray", fontSize: 12, marginTop: 4 }}
        >
          Belege bitte beifügen über Scan-Button <HiOutlineTicket /> .
        </div>
      )}

    </>
  ),
},
      {
        title: "Mitfahrer/Fahrer",
        key: "passengers",
        dataIndex: "passengers",
        width: 150,
        render: (_, record) => {
          const allPassengers = record.expandedData
            .filter((entry) => entry.passenger) // Nur Einträge mit gewähltem Transportmittel
            .map((entry) => {
             // const icon = transportIcons[entry.transportMode] || null;
              const value = entry.passenger;
              
              return value ? (
                <span key={entry.key} 
                style={{ 
                  overflowWrap: 'break-word',
                  wordBreak: 'break-all',
                  whiteSpace: 'pre-wrap'  } }>
                   {value}
                </span>
              ) : null;
            });
      
          return allPassengers.length > 0 ? allPassengers.reduce((prev, curr) => [prev,", ", curr]) : null;
        }, 
      }, 
      {
        title: "Begründung",
        key: "reasons",
        dataIndex: "reasons",
        width: 200,
        render: (_, record) => {
          const allReasons = record.expandedData
            .filter((entry) => entry.reason) // Nur Einträge mit gewähltem Transportmittel
            .map((entry) => {
             // const icon = transportIcons[entry.transportMode] || null;
              const value = entry.reason;
              
              return value ? (
                
                <span  key={entry.key}  style={{ color: 'gray', 
                fontSize: 12, 
                overflowWrap: 'break-word',
                wordBreak: 'break-all',
                whiteSpace: 'pre-wrap'  } }>
                   {value}
                </span>
              ) : null;
            });
      
          return allReasons.length > 0 ? allReasons.reduce((prev, curr) => [prev,", ", curr]) : null;
        }, 
      },
    {
      title: "Erstattung",
      key: "payback",
      dataIndex: "payback",
      width:105,
      render: (_, record) => {
          const value = record.payback??0
           
              
              return value ? (
                <span>
                   {value.toFixed(2).replace(".",",")} €
                </span>
              ) : null;
            }
    },
    

  ];

  const expandColumns = (parentKey) => [
    {
      title: "Aktionen",
      key: "actions",
      width: 100,
      render: (_, record, index) => {
        const parentItem = tripData.find((item) => item.key === parentKey);
        const isLastRow = parentItem && index === parentItem.expandedData.length - 1;
        return(
        <>
          <Button icon={<CopyOutlined />} type="text" size="small" onClick={() => handleCopySubRow(parentKey, record.key)} />
          <Button icon={<SnippetsOutlined />} type="text" size="small" onClick={() => handlePasteSubRow(parentKey)} disabled={!copiedSubRow} />
          <Popconfirm
            title= "Sind Sie sicher, dass Sie dieses Reiseziel löschen möchten?"
            onConfirm = {() => handleDeleteSubRow(parentKey, record.key)}
            okText="Ja"
            cancelText="Abbrechen"
          >        
          <Button icon={<DeleteOutlined />} type="text" size="small" />
          </Popconfirm>
         { isLastRow && 
          (<Button icon={<PlusOutlined />} type="text" size="small" onClick={() => handleAddSubRow(parentKey)} />)

         }
        </>
      );},
    },
    {
      title: "Adresse",
      dataIndex: "address",
      key: "address",
      width: 300,
      render: (text, record) =>
       
          <AddressInput
            value={{ ...record.address }}
            personalData={personalData}
            schoolData={schoolData}
            visitedPlaces={visitedPlaces}
            onChange={(newAddress) => {
              updateExpandedAddress(parentKey, record.key, newAddress);
            }}
            onBlur={(address) => {handleAddressBlur(parentKey,record); handleVisitedPlaceBlur(address) }}
            
          />
      
    },

    {
      title: "Verkehrsmittel",
      dataIndex: "transportMode",
      key: "transportMode",
      render: (text, record,index) => {
        const parentItem = tripData.find((item) => item.key === parentKey);
        const isLastRow = parentItem && index === parentItem.expandedData.length - 1;
        return !isLastRow ? (
        <Select
          placeholder="Verkehrsmittel"
          value={text|| undefined}
          onChange={(value) => handleTransportChange(parentKey, record.key, value)}
          
          style={{ width: "100%", maxWidth: "150px" }}
        >
          
          <Select.Option value="Öffentliche">Öffentliche mit Monatsticket</Select.Option>
          <Select.Option value="ÖffentlicheOhneMonatsticket">Öffentliche ohne Monatsticket</Select.Option>
          <Select.Option value="Kfz">Kfz</Select.Option>
          <Select.Option value="Fahrgemeinschaft">Fahrgemeinschaft</Select.Option>
          <Select.Option value="KfzDienstlich">Kfz (dienstl.)</Select.Option>
          <Select.Option value="Fahrrad">Fahrrad</Select.Option>
          <Select.Option value="Mitfahrgelegenheit">Mitfahrgelegenheit</Select.Option>
        </Select>
      ):null;
    },
  },
    {
      title: "Entfernung / Ticketpreis",
      key: "distanceOrPrice",
      render: (text, record, index) => {
        const isDistanceEditable = ["Kfz", "Fahrgemeinschaft", "KfzDienstlich", "Fahrrad"].includes(record.transportMode);
        const isPriceEditable = ["Öffentliche","ÖffentlicheOhneMonatsticket"].includes(record.transportMode);
        const withoutMonthlyTicket = record.transportMode === "ÖffentlicheOhneMonatsticket";
        const parentItem = tripData.find((item) => item.key === parentKey);
        const isLastRow = parentItem && index === parentItem.expandedData.length - 1;
        const autoDistance = record.segmentDistanceOpenRouteService || 0;
        const enteredDistance = record.segmentDistance || 0;
        const showAlert = parseFloat(enteredDistance) > parseFloat(autoDistance*1.05+2) && autoDistance > 0;
        const startAddress = formatAddress(parentItem.expandedData[index]?.address);
        const endAddress = parentItem.expandedData[index + 1]
          ? formatAddress(parentItem.expandedData[index + 1].address)
            : ""; 

   
   
        return !isLastRow ? (
          <div>
          {showAlert && (
          <Alert
            message="Die eingegebene Entfernung ist größer als die automatisch berechnete Distanz.
            Bitte eine Begründung eingeben. Vielen Dank!"
            type="info"
            showIcon
            closable
            style={{ marginBottom: 8, maxWidth:300 }}
          />
        )}

        {isPriceEditable && !withoutMonthlyTicket && monthlyTicketData.active && (
<Alert
            message="Zur Verrechnung mit dem Monatsticket bitte den aktuellen Einzelticketpreis für die angegebene Fahrstrecke angeben. Vielen Dank!"
            type="info"
            showIcon
            closable
            style={{ marginBottom: 8, maxWidth:300 }}
          />
        )}
        
          <Space.Compact>
          {isDistanceEditable && (<InputNumber
            type = "number"
            onFocus={() => updateSegmentDistances(parentKey, true)}
            controls = {false}
            suffix = {"km"}
            addonBefore ={
            <div className="icon-container">

    <span className="icon-amount">
    
   {Number.isFinite(parseFloat(record.segmentDistanceOpenRouteService))
  ? parseFloat(record.segmentDistanceOpenRouteService).toFixed(1).replace(".", ",")
  : <MdDownloading />} km 

    </span>
    <Button
  onClick={() => updateSegmentDistances(parentKey, true)}
  size="small"
  icon={<CiMap className="icon-gray" />}
/>

  </div>}

addonAfter={
  
  
        <a
          href={`https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(`${startAddress}`)}&destination=${encodeURIComponent(`${endAddress}`)}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button 
          type="link" 
          size="small"
          style={{ height: 30, lineHeight: "30px", padding: "0 8px" }}
          icon={<SiGooglemaps className="icon-gray" />} />
        </a>

      }

            value={record.segmentDistance || undefined}
            onChange={(value) => 
              { const isDistanceToLarge = parseFloat(enteredDistance) > parseFloat(autoDistance*1.05+2) && autoDistance > 0;
                setTripData((prevData) =>
                prevData.map((item) =>
                  item.key === parentKey
                    ? {
                        ...item,
                        expandedData: item.expandedData.map((subItem, subIndex) =>
                          subItem.key === record.key && !isDistanceToLarge
                            ? { ...subItem, segmentDistance: value, ticketPrice:null, reason:"" }
                            : subItem.key === record.key ? { ...subItem, segmentDistance: value, ticketPrice: null} 
                            : subItem
                        ),
                      }
                    : item
                )
              )
              
            }}
            style={{ width: "100%", maxWidth: "220px" }}
          />)}
          </Space.Compact>
          <Space.Compact>
          {isPriceEditable && (<InputNumber
          type = "number"
          precision={2}
          controls = {false}
          addonBefore= {!withoutMonthlyTicket && (<div className="icon-container">
    <span className="icon-amount">
      {`${monthlyTicketData.price ? `${monthlyTicketData.price.toFixed(2).replace(".",",")} €`: ""}`}
    </span>
    <FaRegAddressCard className="icon-gray" />
  </div>)}
        
          suffix ={"€"}
          
  
addonAfter={
  <div className="icon-container">
    <span className="icon-amount">
      {`${(record.payBackTicketPrice?? 0).toFixed(2).replace(".",",")} €`}
    </span>
    <PiHandCoinsLight className="icon-gray" /> 
  </div>
}
          value={record.ticketPrice}
          onChange={(value) => {
            setTripData((prevData) =>
              prevData.map((item) =>
                item.key === parentKey
                  ? {
                      ...item,
                      expandedData: item.expandedData.map((subItem) =>
                        subItem.key === record.key ? { ...subItem, ticketPrice: value, segmentDistance: null } : subItem
                      ),
                    }
                  : item
              )
            );
             
            }
          }
          style={{ width: "100%", maxWidth: "270px" }}
        />)}
          </Space.Compact>


          </div>
          
          
        ): null;
      },
    },
    {
      title: "Mitfahrer/Fahrer",
      dataIndex: "passenger",
      key: "passenger",
      
      render: (text,record) => {
       
       const isCarpool = record.transportMode === "Fahrgemeinschaft";
       const isPassenger =record.transportMode === "Mitfahrgelegenheit";
        return (isCarpool || isPassenger) && 
        (<TextArea 
        placeholder={isCarpool ? "Namen der Mitfahrer": "Name des Fahrers"}
        status={!record.passenger || record.passenger.trim() === "" ? "error" : ""}
        autoSize={{ minRows: 1, maxRows: 3 }}
        value={record.passenger || undefined}
        onChange={(e) => 
            setTripData((prevData) =>
              prevData.map((item) =>
                item.key === parentKey
                  ? {
                      ...item,
                      expandedData: item.expandedData.map((subItem) =>
                        subItem.key === record.key ? { ...subItem, passenger: e.target.value } : subItem
                      ),
                    }
                  : item
              )
            )
          }
      allowClear
         />)}
    },
    {
      title: "Begründung",
      dataIndex: "reason",
      key: "reason",
      render: (text,record) => {
       const requiresReason = (parseFloat(record.segmentDistance)>parseFloat(record.segmentDistanceOpenRouteService)*1.05+2) 
       && ["Kfz", "Fahrgemeinschaft", "KfzDienstlich", "Fahrrad"].includes(record.transportMode);
        return requiresReason && (
        <TextArea 
        autoSize={{ minRows: 1, maxRows: 3 }}
        placeholder="z. B. Route über ..."
        status={!record.reason || record.reason.trim() === "" ? "error" : ""}
        value={record.reason || undefined}
        onChange={(e) =>
            setTripData((prevData) =>
              prevData.map((item) =>
                item.key === parentKey
                  ? {
                      ...item,
                      expandedData: item.expandedData.map((subItem) =>
                        subItem.key === record.key ? { ...subItem, reason: e.target.value } : subItem
                      ),
                    }
                  : item
              )
            )
          }
        allowClear
        disabled={!requiresReason}
         />)}
    },


  ];



  

  const expandedRowRender = (parent) => (
      <div 
      style={{ 
        position: 'relative',
        margin: '8px 0',
        backgroundColor: '#f8fafc',
        borderRadius: 0,
        padding: 16,
        borderLeft: '5px solid gray',
        boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
      }}>
        
        {/* Parent-Info Header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          marginBottom: 12,
          paddingBottom: 8,
          borderBottom: '1px solid #f0f0f0'
        }}>
          <span style={{
            display: 'inline-block',
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: '#1890ff'
          }} />
          <span style={{ 
            fontWeight: 500,
            
            fontSize: 13
          }}>
            Reisedetails für:  {(parent?.date && dayjs(parent.date).locale('de').format('dd DD.MM.YYYY')) || 'Kein Datum'}
          </span>
        </div>
        
      <Table
       className="test"
        columns={expandColumns(parent.key)}
        dataSource={parent.expandedData}
        pagination={false}
        showHeader={false}
      style={{
        backgroundColor: 'transparent'
      }}
      rowClassName={() => 'expanded-row'}
        rowKey="key"
      />
     </div>
   
  );

  return (
    <>



      {/* Haupt-Toolbar */}
      <div
  style={{
    backgroundColor: '#fff',
    padding: '16px 24px',
    marginBottom: 16,
    borderRadius: 8,
    boxShadow: '0 1px 4px rgba(0,21,41,0.08)',
  }}
>
  {/* Erste Zeile: Toolbar mit Flexbox */}
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: 16,
    }}
  >
    {/* Linke Seite */}
    <div style={{ display: 'flex', gap: 8 }}>
      <Upload accept=".json" beforeUpload={handleImport} showUploadList={false}>
        <Button 
        type="default" 
        icon={<UploadOutlined />} 
        style={{ borderStyle: 'dashed' }}>
          Import
        </Button>
      </Upload>
      <Button
        type="default"
        icon={<DownloadOutlined />}
        onClick={() => { 
          if(dataProtection){
            setShowAlertDataProtection(false);
            handleExport();
          }
          else {
            setShowAlertDataProtection(true);
          }
          
        }}
        style={{ borderStyle: 'dashed' }}
      >
        Export
      </Button>
      <Button
        icon={<FilePdfOutlined />}
        onClick={() => { 

          if (confirmation.confirmed && confirmation.name && dataProtection && !missingData) {
            setShowAlertConfirmation(false);
            setShowAlertStatusError(false);
            exportPDF(tripData, personalData, schoolData, confirmation, billingPeriod, monthlyTicketData)
  .then(({ blob, fileName }) => {
    const subject = `Reisekostenabrechnung ${billingPeriod?.[0] || ""} – ${billingPeriod?.[1] || ""}`;
    const body =
      `Guten Tag,\n\nanbei erhalten Sie meine Reisekostenabrechnung für den Zeitraum ` +
      `${billingPeriod?.[0] || ""} bis ${billingPeriod?.[1] || ""}.\n\n` +
      `Mit freundlichen Grüßen\n${personalData?.firstname || ""} ${personalData?.name || ""}`;

    setMailModal({
      open: true,
      blob,
      fileName,
      recipient: "haushalt@seminar-gym-es.kv.bwl.de" || "",
      subject,
      body,
    });
  });
          } else if (missingData)  {
            setShowAlertStatusError(true);

          } 
          else {
            setShowAlertConfirmation(true);
          }
          

        }}
        style={{ borderStyle: 'dashed' }}
      >
        PDF Export
      </Button>
    </div>

    {/* Rechte Seite */}
    <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <label style={{ fontWeight: 500 }}>Monatsticket:</label>
        <Switch
          checkedChildren="Ja"
          unCheckedChildren="Nein"
          checked={monthlyTicketData.active}
          onChange={(value) => {
            setMonthlyTicketData((prev) => ({
              ...prev,
              active: value,
              ...(!value ? { price: '', validityPeriod: [] } : {}),
            }));
          }}
        />
      </div>

      {monthlyTicketData.active && (
        <> <ConfigProvider locale={deDE}>
          <DatePicker.RangePicker
  style={{width:240}}
  format="DD.MM.YY"
  value={
    monthlyTicketData.validityPeriod
      ? [
          dayjs(monthlyTicketData.validityPeriod[0]),
          dayjs(monthlyTicketData.validityPeriod[1]),
        ]
      : null
  }
  onChange={(dates) => {
    setMonthlyTicketData(prev => ({
      ...prev,
      validityPeriod: toIsoDateRange(dates),
    }));
  }}
/>
          </ConfigProvider>

          <InputNumber
            style={{ width: 180 }}
            addonBefore="Preis"
            type = "number"

            precision={2}
            suffix="€"
            placeholder="Ticketpreis"
            value={monthlyTicketData.price}
            onChange={(value) =>
              setMonthlyTicketData((prev) => ({
                ...prev,
                price: value,
              }))
            }
          />
        </>
      )}
    </div>
  </div>

  {/* Zweite Zeile: Alert (falls sichtbar) */}
  {showAlertConfirmation && (
    <div style={{ marginTop: 16 }}>
      <Alert
        message="Vor dem PDF-Export müssen Sie die Richtigkeit Ihrer Angaben und die Datenschutzhinweise bestätigen. Wechseln Sie hierzu zur Formularseite."
        type="info"
        showIcon
        closable
        onClose={() => setShowAlertConfirmation(false)}
      />
    </div>
  )}

{showAlertDataProtection && (
    <div style={{ marginTop: 16 }}>
      <Alert
        message="Vor dem Export müssen Sie die Datenschutzhinweise bestätigen. Wechseln Sie hierzu zur Formularseite."
        type="info"
        showIcon
        closable
        onClose={() => setShowAlertDataProtection(false)}
      />
    </div>
  )}




{ showAlertStatusError && (
    <div style={{ marginTop: 16 }}>
      <Alert
        message="Es fehlen noch Angaben."
        type="info"
        showIcon
        closable
      />
    </div>
  )}


</div>

  
          
     

      {/* Gesamterstattung - fest positioniert unter der Toolbar */}
      <div className="periodAndRefund" style={{
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 16,
        marginRight: 24,
        marginLeft: 24,
      }}>


{/* Neuer Eintrag auf der linken Seite */}
  <div className="styleBillingPeriod" style={{ 
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '8px 8px',
    backgroundColor: '#f0f7ff',
    borderRadius: 4,
    border: '1px solid #d0e3ff'
  }}>
    <span style={{ fontWeight: 500 }}>Abrechnungszeitraum: {billingPeriod[0]} - {billingPeriod[1]} </span>
    
  </div>



        <div className="styleTotalRefund" style={{ 
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '8px 8px',
          backgroundColor: '#f0f7ff',
          borderRadius: 4,
          border: '1px solid #d0e3ff'
        }}>
          <span style={{ fontWeight: 500, }}>Gesamterstattung:</span>
          <span style={{ 
            fontWeight: 600,
            color: '#1890ff',
            fontSize: 16
          }}>{(totalRefund??0).toFixed(2).replace(".",",")} €</span>
        </div>
      </div>
  
      {/* Tabelle */}
      <Table 
       scroll={{ x: 'max-content' }}
        dataSource={tripData}
        columns={columns}
        pagination={false}
        expandable={{ expandedRowRender,
        expandIcon: ({ expanded, onExpand, record }) =>
        expanded ? (
          <DownOutlined onClick={e => onExpand(record, e)} />
        ) : (
          <RightOutlined onClick={e => onExpand(record, e)} />
        ) }}
        style={{
          backgroundColor: '#fff',
          borderRadius: 8,
          overflow: 'hidden'
        }}
      />
    <MailClientModal
  open={mailModal.open}
  onClose={() => setMailModal((prev) => ({ ...prev, open: false }))}
  blob={mailModal.blob}
  fileName={mailModal.fileName}
  recipient={mailModal.recipient}
  subject={mailModal.subject}
  body={mailModal.body}
/> 
    </>
  );
}


export default TripTable;


